import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger.js'
import DrawSvgPlugin from '../vendor/DrawSVGPlugin.js'

gsap.registerPlugin(DrawSvgPlugin)
gsap.registerPlugin(ScrollTrigger)

export default () => {
    gsap.fromTo('[data-scroll-draw] path', {
        drawSVG: '0%',
    },
    {
        drawSVG: '100%',
        ease: 'none',
        scrollTrigger: {
            trigger: '[data-scroll-draw]',
            scrub: 1,
            once: true,
            start: 'top 75%',
            end: 'bottom bottom-=500',
        },
    })

    gsap.fromTo('[data-about-draw] path', {
        drawSVG: '0%',
    },
    {
        drawSVG: '100%',
        ease: 'none',
        scrollTrigger: {
            trigger: '[data-about-draw]',
            scrub: 1,
            once: true,
            start: 'top 40%',
            end: 'bottom bottom',
        },
    })

    ScrollTrigger.create({
        trigger: '#infographic_status',
        start: 'top: 66%',
        once: true,
        onEnter: window.initStatusInfographic,
    })
}
